import React, { useMemo } from 'react';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const Table = (props) => {
    const {
        apiRef,
        className = '',
        columns,
        columnVisibilityModel,
        customNoRowsOverlay,
        customNoRowsOverlayProps = {},
        customToolbar,
        customToolbarProps = {},
        data,
        disableColumnMenu = true,
        disableColumnSorting = false,
        initialState = {},
        onRowClick,
        onSortChange,
        pagination = false,
        rowsPerPageOptions = [5, 10, 20],
        paginationModel,
        sortModel = [{ field: 'Name', sort: 'asc' }],
        themeOptions,
        sx,
        ...otherProps
    } = props

    // Backup apiRef if not provided
    const defaultApiRef = useGridApiRef();
    const finalApiRef = apiRef || defaultApiRef;

	// Merge custom theme with default theme
    const mergedTheme = useMemo(() => {
        return createTheme({
            // Default theme settings
            components: {
                MuiDataGrid: {
                    styleOverrides: {
                        root: {
                            '.MuiDataGrid-overlay': {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                            },
                        },
                        cell: {
                            '&:focus': {
                                outline: 'none',
                            }
                        },
                        columnHeader: {
                            '&:focus': {
                                outline: 'none',
                            },
                            '&:focus-within': {
                                outline: 'none',
                            }
                        }
                    },
                },
            },
            ...themeOptions,
        });
    }, [themeOptions]);

    const DefaultNoRowsOverlay = useMemo(() => (
        <div className='flex row-no-records'>
            <p>No records found.</p>
        </div>
    ), []);

    const combinedInitialState = useMemo(() => ({
        sorting: {
            sortModel: sortModel,
        },
        pagination: {
            paginationModel: paginationModel,
        },
        ...initialState,
    }), [initialState, sortModel, paginationModel]);

    const handleRowClick = (event) => {
        if (onRowClick) {
            onRowClick(event.row);
        }
    };

    const handleSortChange = (event) => {
        if (onSortChange) {
            onSortChange(event);
        }
    };
    
    return (
        <ThemeProvider theme={mergedTheme}>
            <DataGrid
                apiRef={finalApiRef}
                className={className}
                rows={data}
                columns={columns}
                disableColumnMenu={disableColumnMenu}
                columnVisibilityModel={columnVisibilityModel}
                onRowClick={handleRowClick}
                onSortModelChange={handleSortChange}
                slots={{
                    noRowsOverlay: customNoRowsOverlay || DefaultNoRowsOverlay,
                    noResultsOverlay: customNoRowsOverlay || DefaultNoRowsOverlay,
                    toolbar: customToolbar,
                }}
                slotProps={{
                    toolbar: customToolbar ? { ...customToolbarProps } : {},
                    noRowsOverlay: customNoRowsOverlay ? { ...customNoRowsOverlayProps } : {},
                }}
                initialState={combinedInitialState}
                density="compact"
                pageSizeOptions={rowsPerPageOptions}
                pagination={pagination}
                hideFooter={!pagination}
                paginationModel={paginationModel}
                sx={sx}
                {...otherProps}
            />
        </ThemeProvider>

    );
};
export default Table;